module.exports = __webpack_public_path__ + "static/media/swingHardwareMain.b69db793.png";